import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  bar: {
    width: "38px",
    height: "4px",
    flexShrink: 0,
    marginTop: 8,
    marginBottom: 10,
    borderRadius: "100px",
    background: "#E2E2E2",
  },
  drawerHeading: {
    color: "#212121",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "22px",
    letterSpacing: "0.032px",
  },
  noBtn: {
    background: "none",
    border: "none",
  },
  marginHeadingDrawer: {
    margin: "auto 16px 16px 16px",
  },
  date: {
    color: "#212121",
    fontWeight: 500,
    marginBottom: "35px",
  },
  hr: {
    opacity: 0.20000000298023224,
    background: "#FFF",
    height: "1px",
    marginLeft: -16,
    marginRight: -16,
  },
  flex: {
    display: "flex",
  },
  flexWrap: {
    flexWrap: "wrap",
  },
  flexCol: {
    flexDirection: "column",
  },
  spaceBw: {
    justifyContent: "space-between",
  },
  justifyCenter: {
    justifyContent: "center",
  },
  alignCenter: {
    alignItems: "center",
  },
  alignEnd: {
    alignItems: "end",
  },
}));
export default useStyles;
